import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { People } from "../utils/types/peopleList";

export const fetchPeopleList = async () => {
  const response = await axiosServices.get(`/people`);
  return convertToCamelCase<People[]>(response.data.data);
};

export const updatePeopleList = async (id: string, data: any) => {
  const inputData = convertToSnakeCase(data);

  const response = await axiosServices.put(`/people/${id}`, inputData);
  // Make sure this returns the complete person object with personId
  return convertToCamelCase<People>(response.data.data); // Note: .data.data if needed
};

export const deletePeopleData = async (id: string) => {
  const response = await axiosServices.delete(`/people/${id}`);
  return { success: response.data.success, id };
};

export const addPersonData = async (data: { [key: string]: any }) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(`/people`, inputData);
  return convertToCamelCase<People>(response.data.data);
};
